import { useEffect } from "react";
import { useVehiclesStore } from "../../context/useVehiclesStore";
import { useUserAuthStore } from "../../context/useUserAuthStore";
import { useSensorsStore } from "../../context/useSensorsStore";

export default function LinkingTab() {
  const { vehicles, fetchVehicles, linkVehicle } = useVehiclesStore();
  const { users, currentUser, fetchUsers } = useUserAuthStore();
  const { sensors, fetchSensors } = useSensorsStore();

  // Load all required data when the tab is opened
  useEffect(() => {
    if (!vehicles.length) fetchVehicles();
    if (!users.length) fetchUsers();
    if (!sensors.length) fetchSensors();
  }, [vehicles.length, users.length, sensors.length, fetchVehicles, fetchUsers, fetchSensors]);

  if (currentUser?.role !== "admin") {
    return <div className="p-4 text-gray-600">Access denied.</div>;
  }

  return (
    <div>
      <div className="info-box">Assign users and sensors to vehicles.</div>

      {!vehicles.length || !users.length || !sensors.length ? (
        <div>Loading data...</div>
      ) : (
        <div className="table">
          <div className="table-row table-head">
            <div>Vehicle</div>
            <div>Owner</div>
            <div>Sensor</div>
            <div></div>
          </div>

          {vehicles.map((v) => (
            <div className="table-row" key={v.id}>
              <div>{v.registrationNumber}</div>

              {/* Owner Select */}
              <div>
                <select
                  value={v.userId || ""}
                  onChange={(e) =>
                    linkVehicle(v.id, {
                      userId: e.target.value ? Number(e.target.value) : null,
                    })
                  }
                >
                  <option value="">— Unassigned —</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {`${u.firstname} ${u.lastname}`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Sensor Select */}
              <div>
                <select
                  value={v.sensorUnitId || ""}
                  onChange={(e) =>
                    linkVehicle(v.id, {
                      sensorUnitId: e.target.value ? Number(e.target.value) : null,
                    })
                  }
                >
                  <option value="">— Unassigned —</option>
                  {sensors.map((s) => (
                    <option key={s.id} value={s.id}>
                      {`${s.IMEI} (${s.type})`}
                    </option>
                  ))}
                </select>
              </div>

              <div></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
